import { Form, Row, Switch } from "antd";
import { DefaultCriteriaEditorProps } from "../../../../types/bulkEmails/CriteriaOption";
import { useCallback, useEffect, useState } from "react";

export const DefaultSwitchCriteria = ({ value, onChange, formKey, form }: DefaultCriteriaEditorProps) => {
  const [initialized, setInitialized] = useState(false);

  const handleChange = useCallback(
    (selectedValues: boolean) => {
      onChange(selectedValues);
    },
    [onChange]
  );

  useEffect(() => {
    if (!initialized) {
      form.setFieldValue(formKey, false);
      handleChange(false);
      setInitialized(true);
    }
  }, [form, formKey, value, initialized, handleChange]);

  return (
    <Row>
      <Form.Item name={formKey} className="mb-0" valuePropName="checked" preserve={false}>
        <Switch
          onChange={handleChange}
          defaultChecked={false}
          checked={value}
          checkedChildren="Enabled"
          unCheckedChildren="Disabled"
        />
      </Form.Item>
    </Row>
  );
};
